import React, { ReactNode } from 'react';
import { Text, Tooltip } from '@quantum/ui-atoms';
import { Icons24BolderInfoCircle, IconsLgcLogo } from '@/icons';
import * as styles from './styles.module.scss';

interface QuestionLayoutProps {
  text?: string;
  titleMessage?: string;
  tooltipContent?: string | null;
  subtitle?: string | null;
  children: ReactNode;
}

export const QuestionLayout: React.FC<QuestionLayoutProps> = ({
  text,
  subtitle,
  tooltipContent,
  children,
  titleMessage,
}) => (
  <>
    <IconsLgcLogo />
    {text && (
      <Text as='p' className={styles.questionText}>
        <span>{text}</span>
        {titleMessage && <span>{titleMessage}</span>}
      </Text>
    )}
    {subtitle && (
      <Text as='p' className={styles.questionSubtitle}>
        {subtitle}
      </Text>
    )}
    <div className={styles.choiceContainer}>{children}</div>
    {tooltipContent && (
      <Tooltip content={tooltipContent} direction='top'>
        <Tooltip.Button closeOnClick text='Got it' title='Got it' />
        <div className={styles.tooltip}>
          <Icons24BolderInfoCircle className={styles.icon} />
          <Text className={styles.tooltipText} as='p'>
            Why do we ask this?
          </Text>
        </div>
      </Tooltip>
    )}
  </>
);
